import type {
  BlocoDocumento,
  ContextoPaginaDocumento,
} from '@/shared/components/documentos/paginado';

import type { MensagemEmailCertificado } from '../../../types/certificadoAcessosTypes';
import { fatiarConteudoEmail } from '../../../utils/fatiarConteudoEmail';
import { ReplicaEmailFatia } from '../secoes/SecaoTextosEnviados';

/**
 * A cópia do e-mail entra na paginação como N blocos (um por nó de topo), não como um bloco
 * atômico mais alto que a folha A4.
 *
 * `distribuirBlocosEmPaginas` empurra bloco indivisível inteiro para a página seguinte: o que
 * passa de 971px é cortado pelo `overflow-hidden` da página e coberto pelo rodapé, em silêncio.
 * A réplica é o bloco mais alto do documento — e é a cópia íntegra do e-mail enviado, o fato que
 * a Seção 6 existe para provar. Fatiada, o mecanismo de distribuição que já existe resolve.
 *
 * Vive fora do componente de documento porque os DOIS certificados de acessos (o do processo
 * arbitral e o da sentença) montam esta mesma réplica.
 */
export function blocosReplicaEmail(
  mensagem: MensagemEmailCertificado,
  idBase: string,
): BlocoDocumento[] {
  const fatias = fatiarConteudoEmail(mensagem.conteudoHtml);

  return fatias.map((fatia, indice) => ({
    id: `${idBase}-${indice}`,
    render: (contexto: ContextoPaginaDocumento) => (
      <ReplicaEmailFatia
        mensagem={mensagem}
        conteudoHtml={fatia}
        primeira={indice === 0}
        ultima={indice === fatias.length - 1}
        continuacao={indice > 0 && contexto.primeiroDaPagina}
      />
    ),
  }));
}
